// import React from "react";
// import { Link, useLocation } from "react-router-dom";
// import { useState } from "react";
// // import logo from "../../assets/images/teamlogo.png";
// import logo from '../../assets/images/logo.svg'

// const Header = () => {
//   const location = useLocation();
//   // console.log("loc", location.pathname);
//   const [menuIcon, setMenuIcon] = useState(false);
//   const handleSmallerScreen = () => {
//     setMenuIcon(!menuIcon);
//   };

//   return (
//     <header className="!relative left-0 top-0 z-40 w-full border-[#132a00] bg-[#000000db] mt-[70px] duration-300 ease-in lg:!sticky lg:mt-0">
//       <nav className="relative mx-auto container">
//         <div className="flex justify-between items-center lg:p-4">
//           <div className="hidden lg:flex">
//             <Link to="/">
//               <img src={logo} width={150} height={100} alt="approval logo" />
//             </Link>
//           </div>
//           <div className="">
//             <div className="">
//               <ul className="text-1xl flex hidden items-center font-semibold md:gap-4 lg:flex lg:gap-6 2xl:gap-8">
//                 <li
//                   className={`${
//                     location.pathname === "/"
//                       ? "text-[#feaf30]"
//                       : "text-[#ffffffed] "
//                   }`}
//                 >
//                   <Link
//                     to="/"
//                     className="relative inline-block cursor-pointer text-lg font-semibold capitalize leading-3 transition-all duration-500 before:absolute before:-bottom-2 before:left-0 before:h-0.5 before:w-0 before:rounded-full before:bg-[#576EAE] before:opacity-0 before:transition-all before:duration-500 before:content-[''] hover:before:w-full hover:before:opacity-100"
//                   >
//                     Home
//                   </Link>
//                 </li>
//                 <li
//                   className={`${
//                     location.pathname === "/aboutus"
//                       ?  "text-[#feaf30]"
//                       : "text-[#ffffffed] "
//                   }`}
//                 >
//                   <Link
//                     to="/aboutus"
//                     className="relative inline-block cursor-pointer text-lg font-semibold capitalize leading-3 transition-all duration-500 before:absolute before:-bottom-2 before:left-0 before:h-0.5 before:w-0 before:rounded-full before:bg-[#576EAE] before:opacity-0 before:transition-all before:duration-500 before:content-[''] hover:before:w-full hover:before:opacity-100"
//                   >
//                     About
//                   </Link>
//                 </li>
//                 <li
//                   className={`${
//                     location.pathname === "/service"
//                       ?  "text-[#feaf30]"
//                       : "text-[#ffffffed] "
//                   }`}
//                 >
//                   <Link
//                     to="/service"
//                     className="relative inline-block cursor-pointer text-lg font-semibold capitalize leading-3 transition-all duration-500 before:absolute before:-bottom-2 before:left-0 before:h-0.5 before:w-0 before:rounded-full before:bg-[#576EAE] before:opacity-0 before:transition-all before:duration-500 before:content-[''] hover:before:w-full hover:before:opacity-100"
//                   >
//                     Service
//                   </Link>
//                 </li>
//                 <li
//                   className={`${
//                     location.pathname === "/blog"
//                       ?  "text-[#feaf30]"
//                       : "text-[#ffffffed] "
//                   }`}
//                 >
//                   <Link
//                     to="/blog"
//                     className="relative inline-block cursor-pointer text-lg font-semibold capitalize leading-3 transition-all duration-500 before:absolute before:-bottom-2 before:left-0 before:h-0.5 before:w-0 before:rounded-full before:bg-[#576EAE] before:opacity-0 before:transition-all before:duration-500 before:content-[''] hover:before:w-full hover:before:opacity-100"
//                   >
//                     Blog
//                   </Link>
//                 </li>
//                 <li
//                   className={`${
//                     location.pathname === "/contactus"
//                       ?  "text-[#feaf30]"
//                       : "text-[#ffffffed] "
//                   }`}
//                 >
//                   <Link
//                     to="/contactus"
//                     className="relative inline-block cursor-pointer text-lg font-semibold capitalize leading-3 transition-all duration-500 before:absolute before:-bottom-2 before:left-0 before:h-0.5 before:w-0 before:rounded-full before:bg-[#576EAE] before:opacity-0 before:transition-all before:duration-500 before:content-[''] hover:before:w-full hover:before:opacity-100"
//                   >
//                     Contact Us
//                   </Link>
//                 </li>
//                 <li
//                   className={`${
//                     location.pathname === "/joinus"
//                       ?  "text-[#feaf30]"
//                       : "text-[#ffffffed] "
//                   }`}
//                 >
//                   <Link
//                     to="/joinus"
//                     className="relative inline-block cursor-pointer text-lg font-semibold capitalize leading-3 transition-all duration-500 before:absolute before:-bottom-2 before:left-0 before:h-0.5 before:w-0 before:rounded-full before:bg-[#576EAE] before:opacity-0 before:transition-all before:duration-500 before:content-[''] hover:before:w-full hover:before:opacity-100"
//                   >
//                     Join Us
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>

//         {/*mobile screen navigation*/}
//         {/* <p className="block text-base font-bold text-white md:hidden">Ten Stay Munnar</p> */}
//         <div className="fixed left-0 top-0 flex w-full flex justify-between items-center border-b-[1px] border-[#45454512] bg-[#FBFCFD] p-4 lg:hidden">
//           <div className="">
//             <Link to="/">
//               <img src={logo} width={70} height={40} alt="approval logo" />
//             </Link>
//           </div>
//           <div>
//             {menuIcon ? (
//               <button
//                 onClick={handleSmallerScreen}
//                 type="button"
//                 className="collapse-icon flex flex-none rounded-full border border-[#dfdfdf] p-2 hover:text-primary ltr:ml-2 rtl:mr-2 dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
//               >
//                 <svg
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="m-auto h-5 w-5"
//                 >
//                   <path
//                     d="M13 19L7 12L13 5"
//                     stroke="currentColor"
//                     strokeWidth="1.5"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     opacity="0.5"
//                     d="M16.9998 19L10.9998 12L16.9998 5"
//                     stroke="currentColor"
//                     strokeWidth="1.5"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </button>
//             ) : (
//               <div className="flex items-center">
//                 <button
//                   onClick={handleSmallerScreen}
//                   type="button"
//                   className="collapse-icon flex flex-none rounded-full border border-[#dfdfdf] p-2 hover:text-primary ml-2 dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
//                 >
//                   <svg
//                     width="20"
//                     height="20"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="text-[#5f5b5b]"
//                   >
//                     <path
//                       d="M20 7L4 7"
//                       stroke="currentColor"
//                       strokeWidth="1.5"
//                       strokeLinecap="round"
//                     />
//                     <path
//                       opacity="0.5"
//                       d="M20 12L4 12"
//                       stroke="currentColor"
//                       strokeWidth="1.5"
//                       strokeLinecap="round"
//                     />
//                     <path
//                       d="M20 17L4 17"
//                       stroke="currentColor"
//                       strokeWidth="1.5"
//                       strokeLinecap="round"
//                     />
//                   </svg>
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         <div
//           className={
//             menuIcon
//               ? "fixed bottom-0 left-0 right-0 top-[0px] flex h-screen w-full bg-[#98A7D4] text-white duration-300 ease-in lg:hidden"
//               : "fixed left-[-100%] right-0 top-[0px] flex h-screen w-full bg-slate-800 text-white duration-300  ease-in lg:hidden"
//           }
//         >
//           <div className="relative w-full p-4 pt-8">
//             <div className=" flex items-center justify-end">
//               <div className="absolute left-1/2 top-[8%] -translate-x-1/2 -translate-y-1/2 transform">
//                 <Link to="/">
//                   <img src={logo} width={70} height={40} alt="approval logo" />
//                 </Link>
//               </div>
//               <div onClick={handleSmallerScreen} className="">
//                 {menuIcon && (
//                   <button
//                     type="button"
//                     className="border border-[#e9e9e9] collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary ltr:ml-2 rtl:mr-2 dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
//                   >
//                     <svg
//                       width="24"
//                       height="24"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="m-auto h-5 w-5"
//                     >
//                       <path
//                         d="M13 19L7 12L13 5"
//                         stroke="currentColor"
//                         strokeWidth="1.5"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                       <path
//                         opacity="0.5"
//                         d="M16.9998 19L10.9998 12L16.9998 5"
//                         stroke="currentColor"
//                         strokeWidth="1.5"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                     </svg>
//                   </button>
//                 )}
//               </div>
//             </div>

//             <ul className="mt-8 inline-flex flex-col space-y-5 text-base font-semibold">
//               <li
//                 onClick={handleSmallerScreen}
//                 className=" cursor-pointer lg:hidden"
//               >
//                 <Link to="/">Home</Link>
//               </li>
//               <li
//                 onClick={handleSmallerScreen}
//                 className=" cursor-pointer lg:hidden"
//               >
//                 <Link to="/aboutus">About Us</Link>
//               </li>
//               <li
//                 onClick={handleSmallerScreen}
//                 className="cursor-pointer lg:hidden"
//               >
//                 <Link to="/service">Service</Link>
//               </li>
//               <li
//                 onClick={handleSmallerScreen}
//                 className="cursor-pointer lg:hidden"
//               >
//                 <Link to="/contactus">Contact Us</Link>
//               </li>
//               <li
//                 onClick={handleSmallerScreen}
//                 className=" cursor-pointer lg:hidden"
//               >
//                 <Link to="/blog">Blog</Link>
//               </li>
//               <li
//                 onClick={handleSmallerScreen}
//                 className="cursor-pointer lg:hidden"
//               >
//                 <Link to="/Joinus">Join Us</Link>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>
//     </header>
//   );
// };

// export default Header;

import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
// import logo from "../../assets/images/teamlogo.png";
import logo from '../../assets/images/logo.svg'
import { TiArrowSortedDown } from "react-icons/ti";
import { FaLocationDot } from "react-icons/fa6";
import { FaMobileRetro } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";
import Contactus from "../../pages/Contactus/Contactus";



const Header = () => {
  const location = useLocation();
  // console.log("loc", location.pathname);
  const [menuIcon, setMenuIcon] = useState(false);
  const handleSmallerScreen = () => {
    setMenuIcon(!menuIcon);
  };

  const [openDropdown, setOpenDropdown] = useState(null);

  const handleMouseEnter = (dropdown) => {
    setOpenDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };

  const handleClick = () => {
    setOpenDropdown(null);
  };

  // const isActive = (path) => {
  //   return pathname === path ? "border-b-2 border-[#23D768]" : "";
  // };

  // const isServicesActive = (path) => {
  //   return pathname.startsWith(path) ? "border-b-2 border-[#23D768]" : "";
  // };

  //=========== mobile view dropdwon logic===================================

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdownToggle = (dropdown) => {
    setIsDropdownOpen(isDropdownOpen === dropdown ? null : dropdown);
  };

  //=========== mobile view dropdwon logic end===================================

  return (
    <>
      <div className=" bg-[#fdaa2f] p-1">
        <div className="hidden lg:block w-full xl:container">
          <div className="flex items-center justify-between">
            <div className="">
              <div className="flex space-x-7">
                <div className="flex items-center">
                  <FaLocationDot className="text-[#000000a3] text-[18px] font-bold" />
                  <Link className="ml-1 text-[13px]">Aspin Commercial Tower - Shaik Zayed Road</Link>
                </div>
                <div className="flex items-center">
                  <FaMobileRetro className="text-[#000000a3] text-[18px] font-bold" />
                  <Link to="tel:+971554812897" className="ml-1 text-[13px]">
                    +971 55 481 2897</Link>
                </div>
                <div className="flex items-center">
                  <MdEmail className="text-[#000000a3] text-[18px] font-bold" />
                  <Link  to="mailto:info@megavoltdxb.com" className="ml-1 text-[13px]">info@megavoltdxb.com</Link>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-1">
              <div className="flex items-center">
                <div className="p-1 rounded-full bg-[#000000a3]">
                  <Link
                     to="https://www.facebook.com/share/1BChNZSfUP/?mibextid=wwXIfr"
                     target="_blank"
                     rel="noopener noreferrer"
                  >
                    <FaFacebookF className="text-[#ffffffb5] text-[12px] font-bold" />
                  </Link>
                </div>
              </div>
              <div className="flex items-center">
                <div className=" p-1 rounded-full bg-[#000000a3]">
                  <Link
                     to="https://www.instagram.com/megavolt_dubai?igsh=MWMwZmkwcTQ3bW9tMQ%3D%3D"
                     target="_blank"
                     rel="noopener noreferrer"
                  >
                    <FaInstagramSquare className="text-[#ffffffb5] text-[12px] font-bold" />
                  </Link>
                </div>
              </div>
              <div className="flex items-center">
                <div className="p-1 rounded-full bg-[#000000a3]">
                 <Link
                     to="https://x.com/mvts_dxb?s=11"
                     target="_blank"
                     rel="noopener noreferrer"
                  >
                    <FaTwitter className="text-[#ffffffb5] text-[12px] font-bold" />
                  </Link>
                </div>
              </div>
              <div className="flex items-center">
                <div className="p-1 rounded-full bg-[#000000a3]">
                 <Link
                     to="https://www.linkedin.com/in/megavolt-technical-service-co-llc-1703202a2?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                     target="_blank"
                     rel="noopener noreferrer"
                  >
                    <FaLinkedinIn className="text-[#ffffffb5] text-[12px] font-bold" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header className="!relative left-0 top-0 z-40 w-full mt-[60px] duration-300 ease-in lg:!sticky lg:mt-0 bg-black">
        <nav className="relative xl:container mx-auto">
          <div className="flex items-center justify-between p-2 hidden lg:flex">
            <div className="flex my-3">
              <Link to="/">
                <img src={logo} width={200} height={100} alt="approval logo" />
              </Link>
            </div>
            <div className="hidden lg:flex lg:gap-x-12">
              <ul className="flex xl:gap-10 md:gap-4 font-outfit items-center justify-center">
                <li className="">
                  <Link
                    to="/"
                    className={`text-white text-lg inline-block`}
                  >
                    Home
                  </Link>
                </li>
               
                <li
                  className="relative group"
                  onMouseEnter={() => handleMouseEnter("mep")}
                  onMouseLeave={handleMouseLeave}
                >
                  <button className={`text-white text-lg pb-[20px] mb-[-24px]`}>
                    <div className="flex items-center">
                      <span className="mr-1">MEP</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="rotate-90 mt-1"
                      >
                        <path
                          d="M9 5L15 12L9 19"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </button>
                  {openDropdown === "mep" && (
                    <ul className="absolute bg-gray-800 mt-2 top-[40px] border-t-2 border-[#fb992c] w-[200px]">
                      <li
                      className="px-4 py-2 hover:bg-gray-700"
                        onClick={handleClick}
                      >
                        <Link
                          to="/mpez"
                          className="text-white block"
                        >
                          MEP
                        </Link>
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-gray-700"
                        onClick={handleClick}
                      >
                        <Link
                          to="/mpezservice"
                          className="text-white block"
                        >
                          MEP Service
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
              {/*  <li
                  className="relative group"
                  onMouseEnter={() => handleMouseEnter("civil")}
                  onMouseLeave={handleMouseLeave}
                >
                  <button className={`text-white text-lg pb-[20px] mb-[-24px]`}>
                    <div className="flex items-center">
                      <span className="mr-1">Civil</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="rotate-90 mt-1"
                      >
                        <path
                          d="M9 5L15 12L9 19"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </button>
                  {openDropdown === "civil" && (
                    <ul className="absolute bg-gray-800 mt-2 top-[40px] border-t-2 border-[#fb992c] w-[200px]">
                      <li
                        className="px-4 py-2 hover:bg-gray-700"
                        onClick={handleClick}
                      >
                        <Link
                           to="/civil"
                          className="text-white block"
                        >
                          Civil
                        </Link>
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-gray-700"
                        onClick={handleClick}
                      >
                        <Link
                          to="/civilinterior"
                          className="text-white block"
                        >
                          Civil Services
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                 <li className="">
                  <Link
                  target="_blank" // Open in new tab
                  rel="noopener noreferrer" 
                    to="https://megavoltdxb.com"
                    className={`text-white text-lg inline-block`}
                  >
                    Megavolt
                  </Link>
                </li> */}
                <li
                  className="relative group"
                  onMouseEnter={() => handleMouseEnter("interior")}
                  onMouseLeave={handleMouseLeave}
                >
                  <button className={`text-white text-lg pb-[20px] mb-[-24px]`}>
                    <div className="flex items-center">
                      <span className="mr-1">Interior</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="rotate-90 mt-1"
                      >
                        <path
                          d="M9 5L15 12L9 19"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </button>
                  {openDropdown === "interior" && (
                    <ul className="absolute bg-gray-800 mt-2 top-[42px] border-t-2 border-[#fb992c] w-[200px]">
                      <li
                        className="px-4 py-2 hover:bg-gray-700"
                        onClick={handleClick}
                      >
                        <Link
                          to="/interior"
                          className="text-white block"
                        >
                          Interior
                        </Link>
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-gray-700"
                        onClick={handleClick}
                      >
                        <Link
                          to="/interioroutfit"
                          className="text-white block"
                        >
                          Interior Services
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <Link
                    to="/joinus"
                    className={`text-white text-lg inline-block`}
                  >
                    Projects
                  </Link>
                </li>
                <li
                  className="relative group"
                  onMouseEnter={() => handleMouseEnter("approval")}
                  onMouseLeave={handleMouseLeave}
                >
                  <button
                    className={`text-white text-lg pb-[20px] mb-[-24px]`}
                  >
                    <div className="flex items-center">
                      <span className="mr-1">Authority approval</span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="rotate-90"
                      >
                        <path
                          d="M9 5L15 12L9 19"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </button>
                  {openDropdown === "approval" && (
                    <ul className="absolute bg-gray-800 mt-2 top-[40px] border-t-2 border-[#fb992c] w-[300px]">
                      <li
                        className="px-4 py-2 hover:bg-gray-700 capitalize"
                        onClick={handleClick}
                      >
                        <Link
                          to="/approval/municipality-approval"
                          className="text-white block"
                        >
                          dubai municipality approval
                        </Link>
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-gray-700 capitalize"
                        onClick={handleClick}
                      >
                        <Link
                          to="/approval/roadandtransport"
                          className="text-white block"
                        >
                          roads and transport Authority
                        </Link>
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-gray-700 capitalize"
                        onClick={handleClick}
                      >
                        <Link
                          to="/approval/multicommodities-approval"
                          className="text-white block"
                        >
                          dubai electricity and water authority
                        </Link>
                      </li>

                    </ul>
                  )}
                </li>
                <li>
                  {/* <Link
                    to="/blog"
                    className={`text-white text-lg inline-block`}
                  >
                    Blog
                  </Link> */}
                    <a href="https://megavoltdxb.com/blog"  rel="noopener noreferrer"  className={`text-white text-lg inline-block`}>
  Blog
</a>
                </li>
                <li>
                  <Link
                    to="/contactus"
                    className={`text-white text-lg inline-block`}
                  >
                    Contact Us
                  </Link>
                </li>



              </ul>
            </div>

          </div>

          <div className="fixed left-0 top-0 flex w-full flex justify-between items-center p-4 lg:hidden bg-black">
            <div className="">
              <Link to="/">
                <img src={logo} width={150} height={100} alt="approval logo" />
              </Link>
            </div>
            <div>
              {menuIcon ? (
                <button
                  onClick={handleSmallerScreen}
                  type="button"
                  className="collapse-icon flex flex-none rounded-full border border-[#dfdfdf] p-2 hover:text-primary ltr:ml-2 rtl:mr-2 dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="m-auto h-5 w-5"
                  >
                    <path
                      d="M13 19L7 12L13 5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      opacity="0.5"
                      d="M16.9998 19L10.9998 12L16.9998 5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              ) : (
                <div className="flex items-center">
                  <button
                    onClick={handleSmallerScreen}
                    type="button"
                    className="collapse-icon flex flex-none rounded-full border border-[#dfdfdf] p-2 hover:text-primary ml-2 dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-white"
                    >
                      <path
                        d="M20 7L4 7"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                      <path
                        opacity="0.5"
                        d="M20 12L4 12"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M20 17L4 17"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                </div>
              )}
            </div>
          </div>

          <div
            className={
              menuIcon
                ? "fixed bottom-0 left-0 right-0 top-[0px] flex h-screen w-full bg-[#091a2c] text-white duration-300 ease-in lg:hidden"
                : "fixed left-[-100%] right-0 top-[0px] flex h-screen w-full bg-slate-800 text-white duration-300  ease-in lg:hidden"
            }
          >
            <div className="relative w-full p-4 pt-8 h-[100vh]">
              <div className=" flex items-center justify-between">
                <div className="">
                  <Link to="/">
                    <img src={logo} width={150} height={100} alt="approval logo" />
                  </Link>
                </div>
                <div onClick={handleSmallerScreen} className="">
                  {menuIcon && (
                    <button
                      type="button"
                      className="border border-[#e9e9e9] collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary ltr:ml-2 rtl:mr-2 dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="m-auto h-5 w-5"
                      >
                        <path
                          d="M13 19L7 12L13 5"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          opacity="0.5"
                          d="M16.9998 19L10.9998 12L16.9998 5"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  )}
                </div>
              </div>

              <ul className="mt-8 flex flex-col space-y-5 text-base font-outfit p-5 border border-[#80813954] rounded-lg h-[90%]">
                <li
                  onClick={handleSmallerScreen}
                  className=" cursor-pointer lg:hidden"
                >
                  <Link to="/">Home</Link>
                </li>
               
                
                <li className="cursor-pointer lg:hidden">
                  <div
                    onClick={() => handleDropdownToggle("mep")}
                    className="flex items-center justify-between"
                  >
                    <span>MEP</span>
                    <TiArrowSortedDown />
                  </div>
                  {isDropdownOpen === "mep" && (
                    <ul className="mt-2 space-y-3 w-full rounded-lg px-5 py-3 bg-white text-black">
                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer"
                      >
                        <Link to="/mpez">
                          MEP
                        </Link>
                      </li>
                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer"
                      >
                        <Link to="/mpezservice">
                         MEP Service
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li className="cursor-pointer lg:hidden">
                  <div
                    onClick={() => handleDropdownToggle("civil")}
                    className="flex items-center justify-between"
                  >
                    <span>Civil</span>
                    <TiArrowSortedDown />
                  </div>
                  {isDropdownOpen === "civil" && (
                    <ul className="mt-2 space-y-3 w-full rounded-lg px-5 py-3 bg-white text-black">
                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer"
                      >
                        <Link to="/civil">Civil</Link>
                      </li>

                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer"
                      >
                        <Link to="/civilinterior">Civil Services</Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li
                  onClick={handleSmallerScreen}
                  className=" cursor-pointer lg:hidden"
                >
                  <Link
                  target="_blank" // Open in new tab
                  rel="noopener noreferrer" 
                    to="https://megavoltdxb.com"
                    className={`text-white text-lg inline-block`}
                  >Megavolt</Link>
                </li>
                <li className="cursor-pointer lg:hidden">
                  <div
                    onClick={() => handleDropdownToggle("interior")}
                    className="flex items-center justify-between"
                  >
                    <span>Interiors</span>
                    <TiArrowSortedDown />
                  </div>
                  {isDropdownOpen === "interior" && (
                    <ul className="mt-2 space-y-3 w-full rounded-lg px-5 py-3 bg-white text-black">
                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer"
                      >
                        <Link to="/interior">
                          Interior
                        </Link>
                      </li>
                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer"
                      >
                        <Link to="/interioroutfit">
                        Interior Service
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li
                  onClick={handleSmallerScreen}
                  className=" cursor-pointer lg:hidden"
                >
                  <Link to="/joinus">Projects</Link>
                </li>
                <li className="cursor-pointer lg:hidden">
                  <div
                    onClick={() => handleDropdownToggle("approval")}
                    className="flex items-center justify-between"
                  >
                    <span>Authority Approval</span>
                    <TiArrowSortedDown />
                  </div>
                  {isDropdownOpen === "approval" && (
                    <ul className="mt-2 space-y-3 w-full rounded-lg px-5 py-3 bg-white text-black">
                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer capitalize"
                      >
                        <Link to="/approval/municipality-approval">
                          dubai municipality approval
                        </Link>
                      </li>
                      <li
                        onClick={handleSmallerScreen}
                        className="cursor-pointer capitalize"
                      
                      >
                        <Link
                          to="/approval/multicommodities-approval"
                          className="text-black block"
                        >
                          dubai multicommodities approval
                        </Link>
                      </li>


                    </ul>
                  )}
                </li>
                <li
                  onClick={handleSmallerScreen}
                  className=" cursor-pointer lg:hidden"
                >
                  {/* <Link to="/blog">Blog</Link> */}
                     <a href="https://megavoltdxb.com/blog"  rel="noopener noreferrer"  className={`text-white text-lg inline-block`}>
  Blog
</a>
                </li>
                <li
                  onClick={handleSmallerScreen}
                  className=" cursor-pointer lg:hidden"
                >
                  <Link to="/contactus">Contact Us</Link>
                </li>

              </ul>
            </div>
          </div>
        </nav>
 
      </header>
      
    </>

  );
};

export default Header;
